"use client"
import { ScrollArea } from '@/components/ui/scroll-area';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react'
import { loadBrand } from '../Action';
import { Checkbox } from '@/components/ui/checkbox';

interface BrandData {
    id: number;
    brand_title: string;
    brand_title_second: string;
}

export const removeBrandParameter = (url: string, path: string) => {
    const startIndex = url.indexOf(path);
    if (startIndex !== -1) {
        const endIndex = url.indexOf("]", startIndex) + 1;
        if (endIndex !== -1) {
            return url.substring(0, startIndex) + url.substring(endIndex);
        }
    }
    return url;
};



const BrandListCategories = ({
    url,
    catId,
}: {
    url: string;
    catId: number;
}) => {
    const [loading, setLoading] = useState(true);
    const [listBrands, setListBrands] = useState<any>([]);
    const router = useRouter();
    const pathname = usePathname();
    const paths = removeBrandParameter(url, "&brand=[");
    const getBrands = useSearchParams().get("brand");

    let brands: any = getBrands ? JSON.parse(getBrands) : [];

    const addBrandUrl = (id: number) => {
        const check = brands.some((i: any) => i === id);
        if (check) {
            const x = brands.filter((i: any) => i !== id);
            const b = x[0] ? `&brand=${JSON.stringify(x)}` : "";
            router.push(`${pathname}?page=1${paths}${b}`);
        } else {
            brands.push(id);
            const x = JSON.stringify(brands);
            router.push(`${pathname}?page=1${paths}&brand=${x}`);
        }
    };

    const onChecked = (id: number) => {
        const check = brands.some((i: any) => i === id);
        return check;
    };

    useEffect(() => {
        if (loading) {
            loadBrand(catId)
                .then((data) => {
                    setListBrands(data.data);
                    setLoading(false);
                })
        }
    }, [catId, loading]);


    return (
        <ScrollArea className="max-h-32 w-full rounded-md border">
            <div className="p-4">
                <h4 className="mb-4 text-sm leading-none text-right font-bold">برند ها</h4>
                {
                    listBrands.map((i: BrandData) => (
                        <div key={i.id} className="flex w-full items-center justify-between">
                            <div className="flex items-center space-x-2">
                                <Checkbox
                                    checked={onChecked(i.id)}
                                    onClick={() => addBrandUrl(i.id)} id="terms" />
                                <label
                                    htmlFor="terms"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    {i.brand_title_second}
                                </label>
                            </div>
                            <span className="ml-2 text-sm leading-5 font-medium text-gray-900">
                                {i.brand_title}
                            </span>
                        </div>
                    ))
                }
            </div>
        </ScrollArea>
    )
}

export default BrandListCategories